/* Loretana — Mix & Match shared UI (sitemap track · 2026-11-03, owner «ok» to step 2 of the Pre-launch move)
   From the design claude.ai/artifact/VMvWhUyvuiAJQqziQEdu69 (owner 27/10 «add something that shows there is more option»
   and «how user can see the charm bigger»):
   · every sideways row gets ‹ › beside it, shown only on the side that hides options. The row keeps its own swipe;
     the arrows are a mouse/touch shortcut (aria-hidden, no tab stop). Rows drawn later by a builder are wrapped too.
   · window.LxZoom.open([[src, caption], …], from) shows the first photo big with the others as thumbnails; ×, a tap outside
     or Esc closes it and focus goes back (to «from» when the builder redrew the tapped button). Any element with data-lx-zoom="<src>|<caption>" opens it on tap.
   Loaded by each sitemap section that has such a row; the guard keeps it to one run per page. */
(function () {
  if (window.__lxMM) return;
  window.__lxMM = 1;
  var me = document.currentScript;
  var ROWS = '.lx-chips,.lx-nav__sib,.lx-hs__rail,.lx-hs__prail,.lx-rs__chips,.lxp-chips,.lxp-cards,.lx-gifts__cards,[data-lx-hs]';
  var px = function (v) { return parseFloat(v) || 0; };

  function wrap(el) {
    if (el._lxMM || !el.parentNode) return;
    el._lxMM = 1;
    var w = document.createElement('div');
    w.className = 'lx-mm-hs';
    el.parentNode.insertBefore(w, el);
    w.appendChild(el);
    ['l', 'r'].forEach(function (s) {
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'lx-mm-a lx-mm-' + s; a.tabIndex = -1;
      a.setAttribute('aria-hidden', 'true');
      a.textContent = s === 'l' ? '‹' : '›';
      a.addEventListener('click', function () {
        el.scrollBy({ left: (s === 'l' ? -1 : 1) * el.clientWidth * 0.7, behavior: 'smooth' });
        setTimeout(upd, 500);
      });
      w.appendChild(a);
    });
    // the row's own side space (padding, or a bleed to the screen edge) moves to the wrapper, so the arrows sit beside the row
    function pads() {
      el.classList.remove('lx-mm-in');
      var cs = getComputedStyle(el);
      w.style.paddingLeft = Math.max(0, px(cs.marginLeft) + px(cs.paddingLeft)) + 'px';
      w.style.paddingRight = Math.max(0, px(cs.marginRight) + px(cs.paddingRight)) + 'px';
      el.classList.add('lx-mm-in');
    }
    function upd() {
      var max = el.scrollWidth - el.clientWidth;
      w.classList.toggle('can-l', max > 4 && el.scrollLeft > 4);
      w.classList.toggle('can-r', max > 4 && el.scrollLeft < max - 4);
    }
    pads(); upd();
    el.addEventListener('scroll', upd, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(el);
    new MutationObserver(upd).observe(el, { childList: true, subtree: true });
    var vw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== vw) { vw = window.innerWidth; pads(); upd(); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(upd);
    window.addEventListener('load', upd);
  }
  function scan(root) {
    if (!root.querySelectorAll) return;
    if (root.matches && root.matches(ROWS)) wrap(root);
    root.querySelectorAll(ROWS).forEach(wrap);
  }

  // ---------- popup ----------
  // 04/11 owner («with arrows please», sets page charm popup): ‹ › on the photo's sides, ←/→ keys and a swipe go to the previous / next photo
  var lb, img, cap, th, x, pv, nx, go, act = null, cur = 0, shots = [], back = null;
  var ARW = { lt: ['Ankstesnė nuotrauka', 'Kita nuotrauka'], lv: ['Iepriekšējais attēls', 'Nākamais attēls'], et: ['Eelmine pilt', 'Järgmine pilt'] }[(document.documentElement.lang || '').slice(0, 2)] || ['Previous photo', 'Next photo'];
  function step(d) { if (shots.length > 1) show((cur + d + shots.length) % shots.length); }
  // Shopify CDN photos are stored large: ask for a bigger size than the card's
  function big(src) {
    return String(src || '').replace(/_(\d+)x(\d*)(\.\w+)(\?|$)/, '_1200x$3$4').replace(/([?&])width=\d+/, '$1width=1200');
  }
  function build() {
    lb = document.createElement('div');
    lb.className = 'lx-mm-lb'; lb.hidden = true;
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button type="button" class="lx-mm-lb__x">×</button><button type="button" class="lx-mm-lb__a lx-mm-lb__a--p">‹</button><button type="button" class="lx-mm-lb__a lx-mm-lb__a--n">›</button><img class="lx-mm-lb__img" alt=""><p class="lx-mm-lb__cap"></p><button type="button" class="lx-mm-lb__go" hidden></button><div class="lx-mm-lb__th"></div>';
    x = lb.querySelector('.lx-mm-lb__x'); img = lb.querySelector('.lx-mm-lb__img');
    pv = lb.querySelector('.lx-mm-lb__a--p'); nx = lb.querySelector('.lx-mm-lb__a--n'); go = lb.querySelector('.lx-mm-lb__go');
    pv.setAttribute('aria-label', ARW[0]); nx.setAttribute('aria-label', ARW[1]);
    var tx = null;
    img.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) { if (tx === null) return; var d = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(d) > 40) step(d < 0 ? 1 : -1); }, { passive: true });
    cap = lb.querySelector('.lx-mm-lb__cap'); th = lb.querySelector('.lx-mm-lb__th');
    x.setAttribute('aria-label', (me && me.getAttribute('data-lx-close')) || 'Close');
    lb.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lx-i]');
      if (t) { show(+t.getAttribute('data-lx-i')); return; }
      if (e.target.closest('.lx-mm-lb__a--p')) { step(-1); return; }
      if (e.target.closest('.lx-mm-lb__a--n')) { step(1); return; }
      // 04/11 owner (ring builder): «add button as well» - the caller's own action for the photo on show, with a short «Added ✓»
      if (e.target.closest('.lx-mm-lb__go') && act) { act.run(cur); go.textContent = act.done || '✓'; go.classList.add('is-done'); clearTimeout(go._t); go._t = setTimeout(function () { go.textContent = act ? act.label : ''; go.classList.remove('is-done'); }, 1400); return; }
      if (e.target === lb || e.target.closest('.lx-mm-lb__x')) close();
    });
    document.body.appendChild(lb);
  }
  function show(i) {
    var s = shots[i]; cur = i;
    pv.hidden = nx.hidden = shots.length < 2;
    go.hidden = !act; if (act) { clearTimeout(go._t); go.classList.remove('is-done'); go.textContent = act.label; go.setAttribute('aria-label', act.label + ' · ' + (s[1] || '')); }
    img.src = big(s[0]); img.alt = s[1] || '';
    cap.textContent = s[1] || ''; cap.hidden = !s[1];
    lb.setAttribute('aria-label', s[1] || '');
    th.innerHTML = shots.length > 1 ? shots.map(function (z, j) {
      return '<button type="button" data-lx-i="' + j + '" aria-pressed="' + (j === i) + '"><img src="' + String(z[0]).replace(/"/g, '&quot;') + '" alt=""></button>';
    }).join('') : '';
    th.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-label', shots[j][1] || ''); });
  }
  function open(list, from, opt) {
    shots = (list || []).filter(function (s) { return s && s[0]; });
    if (!shots.length) return;
    if (!lb) build();
    opt = opt || {}; act = opt.action || null;
    back = from || document.activeElement;
    show(Math.min(Math.max(+opt.start || 0, 0), shots.length - 1)); lb.hidden = false;
    document.documentElement.classList.add('lx-mm-lock');
    x.focus();
  }
  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('lx-mm-lock');
    if (back && back.focus && document.contains(back)) back.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'Tab') { // keep focus inside the popup
      var f = [].slice.call(lb.querySelectorAll('button')), i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lx-zoom]');
    if (!t) return;
    var v = t.getAttribute('data-lx-zoom').split('|');
    open([[v[0] || t.currentSrc || t.src, v[1] || t.alt || '']]);
  });
  window.LxZoom = { open: open, close: close };

  function boot() {
    scan(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
